import { observer } from "mobx-react";
import useStore from "../../../store";
import { PaymentBreadcrumb } from "../../../config/BreadcrumbConfig";
import { useEffect, useState } from "react";
import PageHeader from '../../../component/PageHeader';
import { Form, Input, Spin } from 'antd';
import ListComponent from "./components/ListComponent";
import InputComponent from "../../../component/InputComponent";

const Payments = observer(() => {
	const { PAYMENT } = useStore();
	const { getMerchantwisePropertyList } = PAYMENT;
	const [merchantLookupLoading, setMerchantLookupLoading] = useState(true);
	const {
		ACCOMMODATION: {
			getMerchantLookupList,
			merchantLookupList,
			merchantDetail
		},
	} = useStore();



	const handleKeyDown = (event) => {
		if (event.key === ' ') {
			event.stopPropagation();
		}
	};

	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			PAYMENT.searchValue = text;
			PAYMENT.setupGrid(PAYMENT.agGrid);
		}
	};
	useEffect(() => {
		return () => {
			PAYMENT.searchValue = '';
			PAYMENT.merchantId = '';
    		PAYMENT.propertyId = '';
    		PAYMENT.propertyList = [];
		};
	}, []);
		return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={PaymentBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>,
					<Form.Item key={2}>
						<InputComponent
							type="select"
							showSearch={true}
							name="eMerchantId"
							placeholder="Select Merchant Name"
							value={PAYMENT.merchantId}
							onInputKeyDown={handleKeyDown}
							onChange={(value) => {
									PAYMENT.merchantId = value;
									PAYMENT.propertyId = '';
									getMerchantwisePropertyList(value)
									PAYMENT.setupGrid(PAYMENT.agGrid);
							}}
							onFocus={() =>
								merchantLookupLoading &&
								getMerchantLookupList().then(() =>
									setMerchantLookupLoading(false)
								)
							}
							notFoundContent={
								merchantLookupLoading ? (
									<Spin size="small" />
								) : (
									'Enter to add new'
								)
							}
							options={{
								values:
									(merchantLookupList.length &&
										merchantLookupList) ||
									(merchantDetail && [
										{
											eMerchantId:
												merchantDetail &&
												merchantDetail.id &&
												merchantDetail.id,
											merchantName:
												merchantDetail &&
												merchantDetail.merchantName &&
												merchantDetail.merchantName,
										},
									]),
								value_key: 'eMerchantId',
								text_key: 'merchantName',
							}}
							style={{ width: '200px', textAlign: 'left' }}
						/>
					</Form.Item>,
					<Form.Item key={3} >
						<InputComponent
							key={`dropdown-${PAYMENT.merchantId}`}
							type="select"
							showSearch={true}
							name="ePropertyId"
							placeholder="Select Property Name"
							disabled ={!PAYMENT.merchantId}
							value={PAYMENT.propertyId}
							onInputKeyDown={handleKeyDown}
							onChange={(value) => {
							PAYMENT.propertyId = value;
							PAYMENT.setupGrid(PAYMENT.agGrid);
							}}
							onFocus={() => {
								if (PAYMENT.merchantId) {
								PAYMENT.getMerchantwisePropertyList(PAYMENT.merchantId);
								}
							}}
							notFoundContent={
								!Array.isArray(PAYMENT.propertyList) || PAYMENT.propertyList.length === 0 ? (
								<Spin size="small" />
								) : (
								'No properties found'
								)
							}
							options={{
								values: Array.isArray(PAYMENT.propertyList) ? PAYMENT.propertyList : [],
								value_key: 'ePropertyId',
								text_key: 'propertyName'
							}}
							style={{ width: '200px', textAlign: 'left' }}
						/>
					</Form.Item>
				]}
			/>
			<ListComponent/>
		</div>
	);
});

export default Payments;